import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('شكراً لتواصلك معنا! سنرد عليك في أقرب وقت ممكن.');
    setFormData({
      name: '',
      email: '',
      company: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2>تواصل معنا</h2>
            <p>نحن متحمسون للحديث عن كيفية التعاون</p>
            <div className="contact-methods">
              <div className="contact-method">
                <span className="method-icon">📧</span>
                <span>hello@msaqeel.com</span>
              </div>
              <div className="contact-method">
                <span className="method-icon">📱</span>
                <span>+966 XX XXX XXXX</span>
              </div>
              <div className="contact-method">
                <span className="method-icon">📍</span>
                <span>الرياض، المملكة العربية السعودية</span>
              </div>
            </div>
          </div>
          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="الاسم"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="البريد الإلكتروني"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="company"
                placeholder="الشركة"
                value={formData.company}
                onChange={handleChange}
              />
              <textarea
                name="message"
                placeholder="رسالتك"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                required
              />
              <button type="submit" className="btn btn-primary">إرسال</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
